const allRoutes = {
  // auth routes routes
  login: "/login",
  register: "/register",
  forgetPassword: "/forgetpassword",
  twoStepVerification: "/two-step-verification",
  success: "/success",
  emailVerification: "/email-verification",
  lockScreen: "/lock-screen",
  resetPassword: "/reset-password",
  pageNotFound: "/page-not-found",
  verifyOtp: "/verify-otp",
  permittedModules: "/available-modules",
  changeNewPassword: "/change-new-password",

  roles: "/roles",
  designationsDetails: "/designation/details",
  departments: "/departments",
  departmentsDetails: "/department/details",
  clientProfile: "/my-profile",

  employeesGrid: "/employees-grid",
  employeesDetails: "/employees/details",
  deals: "/deals",
  dealsDetails: "/deal-details",

  createParty: "/create-party",
  createTeam: "/create-team",

  // Sales Transactions
  createQuotation: "/create-quotation",
  // createPaymentIn: "/create-payment-in",
  createSalesReturn: "/create-sales-return",
  createCreditNote: "/create-credit-note",
  createDeliveryChalan: "/create-delivery-chalan",
  createProformaInvoice: "/create-proforma-invoice",

  // Purchase Transactions
  createPurchase: "/create-purchase",
  createPaymentOut: "/create-payment-out",
  createPurchaseReturn: "/create-purchase-return",
  createDebitNote: "/create-debit-note",
  createPurchaseOrder: "/create-purchase-order",

  // Expenses
  createExpense: "/create-expense",

  // ----- sidebar -----

  dashboard: "/dashboard",
  parties: "/parties",
  customer: "/customer",
  items: "/items",
  warehouse: "/warehouse",
  projects: "/projects",
  tasks: "/tasks",
  // ----- work order -----
  workOrder: "/work-order",
  // ------- projects -----
  projects: "/projects",
  // --- accounts ---
  accounts: "/accounts",
  finance: "/finance",
  purchase: "/purchase",
  sales: "/sales",
  quotationManagement: "/quotation-management",
  contracts: "/contracts",
  // --- hrm section ----
  hrms: "/hrms",
  hrmOfficeShift: "/hrm/office-shift",
  hrmEvents: "/hrm/events",
  hrmHolidays: "/hrm/holidays",
  hrmAwards: "/hrm/awards",
  hrmComplaints: "/hrm/complaints",
  hrmTravels: "/hrm/travels",
  // --- inventory section ---
  inventory: "/inventory",
  // --- Users section ---
  users: "/users",
  // ------ CRM -----
  crm: "/crm",
  transport: "/transport",
  procurement: "/procurement",
  cms: "/cms",
  masters: "/masters",
  financeAndAccountings: "/finance-&-accountings",
  // --- compnay section ---
  company: "/company",
  companyDepartment: "/company/department",
  companyDesignation: "/company/designation",
  companyPolicies: "/company/policies",
  companyAnnouncements: "/company/announcements",
  companyAccessRoles: "/company/access-roles",
  clients: "/clients",
  attendance: "/attendance",
  accounting: "/accounting",
  leaveRequest: "/leave-request",
  training: "/training",
  reports: "/reports",
  settings: "/settings/logo",

  // billbook employees section

  // sales
  salesInvoice: "/sales/sales-invoice",
  creditNotes: "/sales/credit-notes",
  paymentIn: "/sales/payment-in",
  paymentAllocation: "/sales/payment-allocation",

  // purcahse
  purchaseReq: "/purchase/purchase-request",
  purchaseOrder: "/purchase/purchase-order",
  inward: "/purchase/inward",
  purchaseCreditNotes: "/purchase/credit-notes",
  purchaseDebitNotes: "/purchase/debit-notes",

  // payables
  payables: "/payables",
  payablesPaymentIn: "/payables/payment-in",
  payablesPaymentAllocation: "/payables/payment-allocation",

  // employess
  employees: "/employees",
  department: "/employees/department",
  // designations: "/employees/designations",
  role: "/employees/role",

  // settings
  logo: "/settings/logo",
  signature: "/settings/signature",
  address: "/settings/address",
  bankDetails: "/settings/bank-details",
  paymentTerms: "/settings/payment-terms",
  // AWN

  designations: "/designations",
  empolyeesModal: "/empModals",
  employeeProfile: "/employee-profile",
  designationsModal: "/designations-modals",
  branches: "/branches",
  accountSettings: "/account-settings",
  forgotPassword: "/forgot-password",

  // Security Groups
  securityGroups: "/security-groups",

  // Audit Trails
  auditTrail: "/audit-trail",
  customAddonBase: "/custom-addon",
  customAddon: "/custom-addon",
  customAddonBank: "bank",
  customAddonReligion: "religion",
  customAddonJobTitle: "job-title",

  // my profile
  myProfile: "/my-profile",
};

export { allRoutes };
